import loadable from '@loadable/component';
export const manifest = {
  MainCarouselTabs: {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "MainCarouselTabs";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "MainCarouselTabs" */
          './tabs'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./tabs");
            }

            return eval('require.resolve')("./tabs");
          }

        }, {
          resolveComponent: m => m.Tabs
        })
      }
    },
    withCollectorData: true
  },
  MainCarouselLayout: {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "MainCarouselLayout";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "MainCarouselLayout" */
          './layout'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./layout");
            }

            return eval('require.resolve')("./layout");
          }

        }, {
          resolveComponent: m => m.CarouselLayout
        })
      }
    }
  }
};